export default {
  changePassword: {
    title: 'Смена пароля',
    changePasswordButton: 'Сменить пароль',
    currentPassword: 'Текущий пароль',
    newPassword: 'Новый пароль',
    repeatPassword: 'Повторите новый пароль',
    passwordSaved: 'Пароль сохранен!',
    passwordSavedHint: 'Вы под надежной защитой!',
    signIn: 'Войти в аккаунт',
  },
  signIn: {
    forgotPassword: 'Забыли пароль?',
    password: 'Пароль',
    email: 'E-mail',
    captchaLabel: 'Введите символы с картинки',
    signInButton: 'Войти',
    signUpLink: '<0>Еще не зарегистрированы?</0> <1>Регистрация</1>',
    mobile: {
      email: 'Ваш email',
      captchaLabel: 'Цифры с картинки',
    },
  },
  emailConfirm: {
    title: 'Email-подтверждение',
    verificationCodeSubmitted: 'Код подтверждения отправлен на ваш корпоративный email',
    requestCodeTimeout: 'Запросить код повторно можно через',
    requestAnotherCode: 'Запросить другой код',
    sendNewCode: 'Прислать новый код',
    expiredConfirm: 'Срок действия кода подтверждения истек. Прислать вам новый код?',
  },
};
